<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">

      <v-data-table :headers="headers" :items="template_list" class="elevation-1 mytable" dense :search="search">

        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Whatsapp Template Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"></span>

          <v-row dense align="center">
            
            <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
              <v-btn
                rounded
                color="success"
                outlined
                :loading="loader"
                @click="downloadFile"
              >
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-col class="mr-8" sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details />
            </v-col>

            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" small v-on="on">
                  Add Template
                </v-btn>
              </template>

              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text class="pb-2 mt-2">
                    <v-col cols="12">
                        <v-icon color="error" small>*</v-icon>
                        <v-text-field label="Enter Template Name" v-model="editedItem.template_name" outlined />
                        <v-icon color="error" small>*</v-icon>
                        <v-textarea label="Enter Template Data" v-model="editedItem.template_data" rows="5" outlined />

                        <v-text-field label="Variable 1" v-model="editedItem.var1" outlined />
                        <v-text-field label="Variable 2" v-model="editedItem.var2" outlined />
                        <v-text-field label="Variable 3" v-model="editedItem.var3" outlined />
                        <v-text-field label="Variable 4" v-model="editedItem.var4" outlined />
                        <v-text-field label="Variable 5" v-model="editedItem.var5" outlined />
                        <v-text-field label="Variable 6" v-model="editedItem.var6" outlined />
                        <v-text-field label="Variable 7" v-model="editedItem.var7" outlined />
                        <v-text-field label="Variable 8" v-model="editedItem.var8" outlined />
                        <v-text-field label="Variable 9" v-model="editedItem.var9" outlined />
                        <v-text-field label="Variable 10" v-model="editedItem.var10" outlined />

                        <v-checkbox dense v-model="editedItem.is_for_broadcast" color="success" label=" Is For Broadcast?" class="ml-4"></v-checkbox>
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label=" Is Active?" class="ml-4"></v-checkbox>
                  </v-col>
                  </v-card-text>

                  <v-card-actions class="justify-center pt-0">
                    <v-btn class="button" @click="close()" :disabled="!valid">
                       Cancel
                    </v-btn>

                    <v-btn color="primary button" @click="save" :disabled="!valid">
                        {{ editedIndex === -1 ? 'Save' : 'Update' }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>

        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-row>
                <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                </v-avatar>

                <v-avatar size="25" class="delete-avatar ml-2">
                <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                </v-avatar>         
            </v-row>
          </div>
        </template>
        <template v-slot:item.is_for_broadcast="{ item }">
          <span v-if="item.is_for_broadcast">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Template Name",
        align: "left",
        sortable: false,
        value: "template_name",
      },
      {
        text: "Template Data",
        align: "left",
        sortable: false,
        value: "template_data",
      },
      {
        text: "Variable 1",
        align: "left",
        sortable: false,
        value: "var1",
      },
      {
        text: "Variable 2",
        align: "left",
        sortable: false,
        value: "var2",
      },
      {
        text: "Variable 3",
        align: "left",
        sortable: false,
        value: "var3",
      },
      {
        text: "Variable 4",
        align: "left",
        sortable: false,
        value: "var4",
      },
      {
        text: "Variable 5",
        align: "left",
        sortable: false,
        value: "var5",
      },
      {
        text: "Variable 6",
        align: "left",
        sortable: false,
        value: "var6",
      },
      {
        text: "Variable 7",
        align: "left",
        sortable: false,
        value: "var7",
      },
      {
        text: "Variable 8",
        align: "left",
        sortable: false,
        value: "var8",
      },
      {
        text: "Variable 9",
        align: "left",
        sortable: false,
        value: "var9",
      },
      {
        text: "Variable 10",
        align: "left",
        sortable: false,
        value: "var10",
      },
      {
        text: "Is For Broadcast",
        align: "left",
        sortable: false,
        value: "is_for_broadcast",
      },
      {
        text: "Is Active",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      { 
        text: " Actions", 
        value: "action", 
        sortable: false 
      },
    ],
    template_list: [],
    editedIndex: -1,
    editedItem: {
        id: "",
        template_name:"",
        template_data:"",
        var1:"",
        var2:"",
        var3:"",
        var4:"",
        var5:"",
        var6:"",
        var7:"",
        var8:"",
        var9:"",
        var10:"",
        is_for_broadcast:"",
        isactive: ""
    },
    defaultItem: {
        id: "",
        template_name:"",
        template_data:"",
        var1:"",
        var2:"",
        var3:"",
        var4:"",
        var5:"",
        var6:"",
        var7:"",
        var8:"",
        var9:"",
        var10:"",
        is_for_broadcast:"",
        isactive: ""
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Template" : "Edit Template";
    },
    filteredTemplateList() {
        if (!this.search) 
        return this.template_list;
        const txt = this.search.toLowerCase();
        return this.template_list.filter(item => (item.template_name || "").toLowerCase().includes(txt)
    );
  }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    downloadFile() {
    this.loader = true;

    const excelData = this.filteredTemplateList.map((item, index) => ({
      "S.No": index + 1,
      "Template Name": item.template_name,
      "Template Data": item.template_data,
      "Variable 1" : item.var1,
      "Variable 2" : item.var2,
      "Variable 3" : item.var3,
      "Variable 4" : item.var4,
      "Variable 5" : item.var5,
      "Variable 6" : item.var6,
      "Variable 7" : item.var7,
      "Variable 8" : item.var8,
      "Variable 9" : item.var9,
      "Variable 10" : item.var10,
      "Is For Broadcast" : item.is_for_broadcast,
      "Is Active": item.isactive
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Whatsapp Template");
    XLSX.writeFile(workbook, "WhatsappTemplate.xlsx");

    this.loader = false;
  },

    editItem(item) {
      this.editedIndex = this.template_list.indexOf(item);
      this.editedItem= {
        id : item.id,
        template_name : item.template_name,
        template_data : item.template_data,
        var1 : item.var1,
        var2 : item.var2,
        var3 : item.var3,
        var4 : item.var4,
        var5 : item.var5,
        var6  : item.var6,
        var7 : item.var7,
        var8 : item.var8,
        var9 : item.var9,
        var10 : item.var10,
        is_for_broadcast: item.is_for_broadcast,
        isactive : item.isactive
      };
      this.template_name = item.template_name;
      this.template_data = item.template_data;
      this.var1 = item.var1;
      this.var2 = item.var2;
      this.var3 = item.var3;
      this.var4 = item.var4;
      this.var5 = item.var5;
      this.var6 = item.var6;
      this.var7 = item.var7;
      this.var8 = item.var8;
      this.var9 = item.var9;
      this.var10 = item.var10;
      this.is_for_broadcast = item.is_for_broadcast;
      this.isactive = item.isactive;
      this.dialog = true;
    },

    onLoad() {
      this.overlay = true;
      this.name="";
      axios
        .post("/communicationType/getTemplates")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.template_list = res.data.template_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
              if(!this.template_name || !this.template_data){
                 this.showSnackbar("#b71c1c", "Enter Valid Template Name and Data");
                 return
              }  
          axios
            .post("/communicationType/editTemplate", this.editedItem)
            .then((res) => {
              if (res.data.code == "SUCCESS") {
                this.showSnackbar("#4caf50", "Template Updated Successfully...");
                this.close();
                this.onLoad();
              } else if (res.data.code == "NA") {
                this.showSnackbar("#b71c1c", res.data.msg || "Template Already Present!!!");
              } else {
                this.showSnackbar("#b71c1c", "Something went wrong!");
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
        }else{
          this.showSnackbar("#b71c1c", "Enter Template Name and Data...");
        }
      } else {
        if(this.editedItem.template_name && this.editedItem.template_data){
        axios
          .post("/communicationType/saveTemplate", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Template Added Successfully...");
              this.onLoad();
            } else if (res.data.code == "NA") {
              this.showSnackbar("#b71c1c", res.data.msg || "Template Already Present!!!");
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
          this.close();
        }else{
          this.showSnackbar("#b71c1c", "Enter Template Name and Data...");
        }
      }
    }, 

    isValidated() {
      if (this.editedItem.template_name && this.editedItem.template_data) {
        return true;
      } else {
        if (!this.editedItem.template_name) {
          this.errorMsg.template_name = true;
        }
        return false;
      }
    }, 

    toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/communicationType/toggleTemplate", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Template Updated Successfully!");
          } else if (res.data.code == "NA") {
            this.showSnackbar("#4caf50","Something went wrong, Please try again later!");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this Template?")) {
      const data = {
        id: item.id
      };
      axios
        .post("/communicationType/deleteTemplate", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Template Deleted Successfully...");
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      }
      this.close();
    }
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.mytable /deep/ thead th {
  background: #0f2027;
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>